import { Component, ElementRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AppState } from "@app/reducers";
import { CrudService, CustomDirectiveConfig, IApplicationResponse, ModulesBasedApiSuffix, prepareRequiredHttpParams, ResponseMessageTypes, RxjsService, setRequiredValidator, SnackbarService } from "@app/shared";
import { DealerModuleApiSuffixModels } from "@modules/dealer";
import { loggedInUserData } from "@modules/others";
import { UserLogin } from "@modules/others/models";
import { select, Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/api";
@Component({
  selector: 'app-average-contract-add-edit',
  templateUrl: './average-contract-add-edit.component.html'
})

export class AverageContractAddEditComponent {

  averageAddEditDialogForm: FormGroup;
  loggedUser;
  averageContractConfigId;
  isADecimalMaxTwoDigitsTwoDecimals = new CustomDirectiveConfig({ isADecimalMaxTwoDigitsTwoDecimals: true });
  isANumberOnly = new CustomDirectiveConfig({ isANumberOnly: true });
  @ViewChild('inputBox1', { static: false }) inputBox1: ElementRef;
  isANumberZeroToNinetyNine = new CustomDirectiveConfig({ isANumberZeroToNinetyNine: true, shouldPasteKeyboardEventBeRestricted: true });


  constructor(private snackbarService: SnackbarService, private rxjsService: RxjsService, public config: DynamicDialogConfig, public ref: DynamicDialogRef, private store: Store<AppState>,
    private crudService: CrudService) {
    this.rxjsService.setDialogOpenProperty(true);
    this.store.pipe(select(loggedInUserData)).subscribe((userData: UserLogin) => {
      if (!userData) return;
      this.loggedUser = userData;
    });
    this.averageContractConfigId = this.config.data?.row?.averageContractConfigId ? this.config.data?.row?.averageContractConfigId : null;
  }
  ngOnInit(): void {
    this.initForm();
    if (this.averageContractConfigId)
      this.getAverageContractDetail({ ...{ averageContractConfigId: this.averageContractConfigId } });
  }
  ngAfterViewInit() {
    this.inputBox1?.nativeElement?.focus();
  }
  initForm() {
    this.averageAddEditDialogForm = new FormGroup({
      'contractFrom': new FormControl(null),
      'contractTo': new FormControl(null),
      'bonusMultiple': new FormControl(null),
      'dealerBranchAverageContractConfigId': new FormControl(''),
    });
    if (!this.averageContractConfigId)
    this.averageAddEditDialogForm = setRequiredValidator(this.averageAddEditDialogForm, ['contractFrom', 'contractTo', 'bonusMultiple']);
    if(this.config?.data?.row){
      this.averageAddEditDialogForm.addControl('levels', new FormControl(null));
      this.updateFormData(this.config.data.row)
    }
    this.onValueChanges();
  }

  updateFormData(data){
    this.averageAddEditDialogForm.patchValue(data)
    if(data?.bonus){
      this.averageAddEditDialogForm.get("bonusMultiple").setValue(data?.bonus);
    }
  }

  onValueChanges() {
    this.averageAddEditDialogForm
      .get("contractTo")
      .valueChanges.subscribe((contractTo: string) => {
        if (contractTo && Number(contractTo) <= 0){
          this.averageAddEditDialogForm.get("contractTo").setValue("");
          this.snackbarService.openSnackbar("ContractTo should be greater than 0.", ResponseMessageTypes.WARNING);
        }
      });
    this.averageAddEditDialogForm
      .get("contractFrom")
      .valueChanges.subscribe((contractFrom) => {
        if (contractFrom) {
          this.averageAddEditDialogForm.get("contractTo").setValidators([Validators.min(+contractFrom)]);
          this.averageAddEditDialogForm.get("contractTo").updateValueAndValidity();
          this.averageAddEditDialogForm.updateValueAndValidity();
        }
      });
    this.averageAddEditDialogForm
      .get("bonusMultiple")
      .valueChanges.subscribe((bonusMultiple: string) => {
      });
  }
  getAverageContractDetail(params) {
    this.crudService.get(ModulesBasedApiSuffix.DEALER, DealerModuleApiSuffixModels.DEALER_AVERAGE_CONTRACT_DETAIL, null, false,
      prepareRequiredHttpParams(params))
      .subscribe((response: IApplicationResponse) => {
        if (response && response.resources && response.isSuccess) {
          this.setValue(response.resources);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }
  setValue(response) {
    this.averageAddEditDialogForm.get("contractFrom").setValue(response.contractFrom);
    this.averageAddEditDialogForm.get("contractTo").setValue(response.contractTo);
    this.averageAddEditDialogForm.get("bonusMultiple").setValue(response.bonusMultiple);
    this.averageAddEditDialogForm.get("levels").setValue(response.levels);
  }
  onSubmitDialog() {
    if (!this.averageAddEditDialogForm?.valid) {
      return;
    }
    let formValue = this.averageAddEditDialogForm.value;
   this.ref.close(formValue);
  }
  btnCloseClick() {
    this.rxjsService.setDialogOpenProperty(false);
    this.ref.close(false);
  }
}